const SEC = 1000
const MIN = 60 * SEC
const HOUR = 60 * MIN
const DAY = 24 * HOUR

const pad = (parts: TemplateStringsArray, ...values: number[]) => {
  let result = parts[0]

  for (let i = 1; i < parts.length; i++) {
    result += zeropad(values[i - 1]) + parts[i]
  }

  return result
}

const formatMicro = (d: Date, ts: number) => {
  const us = Math.round((ts * 1000) % 1000)
  const ms = d.getMilliseconds()
  const s = d.getSeconds()

  return `${zeropad(s)}:${zeropad3(ms)}.${zeropad3(us)}`
}

const formatMilli = (d: Date) => {
  const ms = d.getMilliseconds()
  const s = d.getSeconds()

  return `${zeropad(s)}:${zeropad3(ms)}`
}

const zeropad = (n: number) => (n < 10 ? '0' + n : '' + n)

const zeropad3 = (t: number) => (t < 10 ? '00' + t : t < 100 ? '0' + t : '' + t)

const getReadableTimeLabel = (ts: number, frame: number) => {
  const d = new Date(ts)

  if (frame < 5) return formatMicro(d, ts)
  else if (frame < 5 * SEC) return formatMilli(d)
  else if (frame < 5 * MIN) return pad`${d.getMinutes()}:${d.getSeconds()}`
  else if (frame < DAY) return pad`${d.getHours()}:${d.getMinutes()}`
  else if (frame < 7 * DAY) return pad`${d.getDate()}.${d.getMonth() + 1} ${d.getHours()}:${d.getMinutes()}`
  else return pad`${d.getDate()}.${d.getMonth() + 1}`
}

const steps = [DAY, HOUR, 10 * MIN, MIN, 10 * SEC, SEC, 100, 10, 1, 0.1]
const calcTimeStep = (frame: number, t0: number, lines: number) => {
  // вычисляем ширину шага при котором на график войдут примерно *lines* линий сетки
  const baseStep = steps.find((v) => 2 * v < frame)
  const count = Math.ceil(frame / (baseStep * lines))
  const step = baseStep * count

  // вычисляем время первой линии сетки (минимальное круглое число кратное шагу и большее чем t0)
  let dayStart = new Date(t0).setHours(0)
  dayStart = dayStart - (dayStart % HOUR)
  const start = dayStart + step * Math.ceil((t0 - dayStart) / step)

  return { step, start }
}

/**
 * Округлить число вверх до второй значащей цифры делящейся на 5
 */
const roundStep = (x: number): number => {
  if (x <= 0 || !x) return 0

  let multiplier = 1
  let step = x

  while (step < 10 || step > 100) {
    const factor = step < 10 ? 10 : 0.1

    step *= factor
    multiplier *= factor
  }

  const result = (5 * Math.ceil(step / 5)) / multiplier
  return result > 10 ? Math.round(result) : result
}

const calcYGrid = (minY: number, maxY: number, maxLines: number) => {
  const step = roundStep((maxY - minY) / maxLines)

  const values: number[] = []
  const result = { step, values }
  if (!step) return result

  let value = minY - (minY % step)
  while (value < maxY) {
    if (value > minY) values.push(value)
    value += step
  }

  return result
}

const axes = { getReadableTimeLabel, calcTimeStep, calcYGrid }
export default axes
